/**
 * Kraje, w ktorych backend zaklada konto Stripe restauracji (backend: CountryCode).
 * Formularz bierze kraj z adresu Google - bez osobnego pola i bez wplywu na walute.
 */
export const SUPPORTED_COUNTRIES = [
  'PL',
  'US',
  // strefa euro
  'AT',
  'BE',
  'CY',
  'DE',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PT',
  'SI',
  'SK',
];

export const isSupportedCountry = (code?: string | null): code is string =>
  !!code && SUPPORTED_COUNTRIES.includes(code);
